// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Hero_logoContainer__nv9hX","title":"Hero_title__lVlSO","description":"Hero_description__2pDIi","menu":"Hero_menu__13Sad"};